import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

const PaginationComponent = ({ path, currentPageNo, totalPages, hasPrevPage, hasNextPage }) => {
    const prevLink = currentPageNo === 2 ? path : `${path}/Page-${currentPageNo - 1}`;
    const nextLink = currentPageNo === 0 ? path : `${path}/Page-${currentPageNo + 1}`;

    return (
        <div className="pt-6 pb-8 space-y-2 md:space-y-5">
            <nav className="flex justify-between">
                {!hasPrevPage && (
                    <button rel="previous" className="cursor-auto disabled:opacity-50" disabled={!hasPrevPage}>
                        &lt; Previous
                    </button>
                )}
                {hasPrevPage && (
                    <a href={prevLink}>
                        <button rel="previous">&lt; Previous</button>
                    </a>
                )}
                <span>
                {currentPageNo} of {totalPages}
                </span>
                {!hasNextPage && (
                    <button rel="next" className="cursor-auto disabled:opacity-50" disabled={!hasNextPage}>
                        Next &gt;
                    </button>
                )}
                {hasNextPage && (
                    <Link to={nextLink}>
                        <button rel="next">Next &gt;</button>
                    </Link>
                )}
            </nav>
        </div>
    )
}

PaginationComponent.propTypes = {
    path: PropTypes.string,
    currentPageNo: PropTypes.number,
    hasPrevPage: PropTypes.bool,
    hasNextPage: PropTypes.bool
}

export default PaginationComponent